import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Button } from '@netbasequid/core'
import SystemMessageLayout from 'components/wrapper/SystemMessageLayout'
import { unsubscribeDashboardBySubscriptionUuId } from 'features/scheduledReport/asyncThunks'
import { useAppDispatch } from 'app/hooks'
import { isFulfilled } from '@reduxjs/toolkit'

import { Title, Content, ButtonContainer, Footer } from './Components'

const UnsubscribeConfirm = ({ dashboardName }: { dashboardName: string }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { subscriptionUuid } = useParams()
  const domainName = window.location.origin

  const handleUnsubscribe = async () => {
    const res = await dispatch(unsubscribeDashboardBySubscriptionUuId(subscriptionUuid!))
    navigate('.', { state: isFulfilled(res) ? 'success' : 'fail' })
  }

  return (
    <SystemMessageLayout>
      <Title>{t('scheduledReportUnsubscribe.confirm.title')}</Title>
      <Content>
        {t('scheduledReportUnsubscribe.confirm.message', {
          name: dashboardName,
          interpolation: {
            escapeValue: false
          }
        })}
      </Content>
      <ButtonContainer>
        <Button mode="dark" color="primary" onClick={handleUnsubscribe}>
          {t('unsubscribe')}
        </Button>
        <Button
          mode="dark"
          color="secondary"
          onClick={() => {
            window.location.replace(`${domainName}/cb/nb/#Home/`)
          }}>
          {t('cancel')}
        </Button>
      </ButtonContainer>
      <Footer>{t('quidCopyright', { year: new Date().getFullYear() })}</Footer>
    </SystemMessageLayout>
  )
}

export default UnsubscribeConfirm
